import { ChevronLeft } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";

const SinglePageTitle = ({
    title,
    link,
}: {
    title: string;
    link: string;
}) => {
    const [params] = useSearchParams();

    const backLink = params.get("back")
        ? decodeURIComponent(params.get("back") as string)
        : link;

    return (
        <div className="flex items-center pl-0 mt-4 mb-5 space-x-2">
            <span>
                <Link to={backLink}>
                    <ChevronLeft size={20} className="-ml-2" />
                </Link>
            </span>
            <h1 className="font-[600] text-tertiary text-[18px]">
                {title}
            </h1>
        </div>
    );
};

export default SinglePageTitle;